import { NotFoundError } from '@cian/peperrors/shared';
export var assertNotFoundResponse = function assertNotFoundResponse(response) {
  if (response.statusCode !== 200) {
    return;
  }
  if (response.response.layout) {
    return;
  }
  throw new NotFoundError({
    domain: 'src/services/assert/assertBadHttpStatus',
    message: 'Layouts HttpBadStatusCodeError'
  });
};